import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { ICardCommonData } from '../card-common-data/card-common-data';

export enum SaleType {
    ForRent = 'For Rent',
    ForSale = 'For Sale',
    ForRentAndSale = 'For Rent & Sele',
    Deposite = 'Deposit Taken'
};
export type PropertyType = string;
export interface IProperty extends ICardCommonData {
    id: string,
    createdAt: string,
    propertyType: SaleType,
    price: number,
    address: string,
    noOfBeds: number,
    residenceType: PropertyType,
    areaInSquareFt: number,
    noOfBaths: number,
    image: string,
}
export class Property implements IProperty {
    createdDaysAgo: number | undefined;
    constructor(
        public readonly id: string,
        public readonly createdAt: string,
        public readonly propertyType: SaleType,
        public readonly title: string,
        public readonly price: number,
        public readonly address: string,
        public readonly noOfBeds: number,
        public readonly residenceType: PropertyType,
        public readonly areaInSquareFt: number,
        public readonly noOfBaths: number,
        public readonly image: string,
        public readonly city:string,
        public readonly place:string
    ) {
        const currentDate = new Date();
        const createdAtDate = new Date(createdAt);
        this.createdDaysAgo = differenceInCalendarDays(currentDate, createdAtDate);
    }
}
